
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Manage Subscriptions',
      url:'#manageSuscriptions',
      target:0,
      badge: null,
      icon: null,
      isShow: 1,
      loader:null,
      body_html: '<div class="flits-recharge-subcription-main"><div class="flits-loading-div flits-rc-integration-loader"> <div class="flits-spinner"></div> </div></div>'
    }
    settings.navs.splice(6, 0, obj);
  });
  // ************************************************************Recahrge Subscription JS***********************************************************
  Flits(document).on('click', '.flits-rc-recent-order-card a', function(event){
    event.preventDefault();
    let orderId = Flits(this).attr('data-order-item');
    if(orderId){
      makeRcDrawer(orderId);
      Flits('.flits-rc-drawer-main').addClass('active');
      Flits('body').addClass('flits-rc-drawer-open');
      Flits('html').addClass('flits-rc-drawer-open');
    }
  });
  Flits(document).on('click', '.flits-rc-recent-orders a', function(event){
    event.preventDefault();
    if(Flits('.flits-rc-purchase-history').hasClass('active')){
      Flits('.flits-rc-purchase-history').removeClass('active');
      Flits(this).text('See all recent orders');
    }
    else{
     Flits('.flits-rc-purchase-history').addClass('active');
    Flits(this).text('Hide recent orders');
    }
  });
  Flits(document).on('click', '.flits-rc-drawer-close', function(event){
    event.preventDefault();
    Flits('.flits-rc-drawer-main').removeClass('active');
    Flits('body').removeClass('flits-rc-drawer-open');
    Flits('html').removeClass('flits-rc-drawer-open');
  });
  function setRcDate(date){
    let currentDate = new Date(date);
    let year = currentDate.getFullYear();
    let month = (1 + currentDate.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    let day = currentDate.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return month + '-' + day + '-' + year;
  }
  function makeRcDrawer(orderId){
    let currentId = Number(orderId);
    let allOrders = window.flitsRcOders
    let data = allOrders.find(order => order.id === currentId);
    if(data){
      let shippingLabel = `<strong>Shipping</strong> </br> ${data.shipping_lines[0].code} (${data.shipping_lines[0].title})`;
      let lineItemClone = Flits('.flits-rc-drawer-order-card-main .flits-rc-drawer-order-card').clone();
      Flits('.flits-rc-drawer-order-card-main').html('');
      Flits('.flits-rc-drawer-order-id .flits-rc-drawer-value').html(data.shopify_order_number);
      Flits('.flits-rc-drawer-order-date .flits-rc-drawer-value').html(setRcDate(data.created_at));
      Flits('.flits-rc-drawer-order-shipping .flits-rc-drawer-label').html(shippingLabel);
      Flits('.flits-rc-drawer-order-shipping .flits-rc-drawer-value').html(Flits.formatMoney(Math.abs(data.shipping_lines[0].price * 100), Flits.money_format));
      // Flits(data.tax_lines).each(function(index, ele){
      //   let taxElem = `<div class="flits-rc-drawer-body-common"><div class="flits-rc-drawer-label">${ele.title} (${ele.rate}%)</div><div class="flits-rc-drawer-value">${Flits.formatMoney(Math.abs(ele.price * 100), Flits.money_format)}</div></div>`;
      //   Flits('.flits-rc-drawer-order-tax').append(taxElem);
      // });
      let totalTax = `<div class="flits-rc-drawer-order-total-tax flits-rc-drawer-body-common">
          <div class="flits-rc-drawer-label">Total Tax</div>
          <div class="flits-rc-drawer-value">${Flits.formatMoney(Math.abs(data.total_tax * 100), Flits.money_format)}</div>
        </div>`;
      Flits('.flits-rc-drawer-order-tax').html(totalTax);
      Flits(data.line_items).each(function(index, ele){
        let lineSubscriptionId = ele.subscription_id;
        let allSubscriptions = window.flitsRcSubscriptions;
        let currentSubscription = allSubscriptions.find(subscription => subscription.id === lineSubscriptionId);
        let lineCard = `<div class="flits-rc-drawer-order-card flits-rc-drawer-body-common">
            <div class="flits-rc-drawer-label">
              <div class="flits-rc-drawer-order-card-img"><img src="${ele.images.small}" alt="" /></div>
              <div class="flits-rc-drawer-order-card-title">${ele.title}</div>
              <div class="flits-rc-drawer-order-card-variant">${ele.variant_title}</div>
              <div class="flits-rc-drawer-order-subscription-freq">Subscription frequency: ${currentSubscription.order_interval_frequency} ${currentSubscription.order_interval_unit}</div>
            </div>
            <div class="flits-rc-drawer-value">${Flits.formatMoney(Math.abs(ele.price * 100), Flits.money_format)}</div>
          </div>`;
        Flits('.flits-rc-drawer-order-card-main').append(lineCard);
      });
      Flits('.flits-rc-drawer-order-total .flits-rc-drawer-value strong').html(Flits.formatMoney(Math.abs(data.total_price * 100), Flits.money_format));
    }
  }
  function makeRcBody(data){
    let itemClone = Flits('.flits-rc-section').clone();
    let upOrders = `/tools/recurring/portal/${data.customer.hash}/schedule?token=${window.flitsRcCustomerToken}`;
    Flits(itemClone).find('.flits-rc-upcoming-orders a').attr('href', upOrders);
    let nextOrder = data.schedule[0];
    if(nextOrder){
        Flits(itemClone).find('.flits-rc-next-order-date strong').html(setRcDate(nextOrder.date)); 
        Flits(nextOrder.orders).each(function(i, elem){
          let nextOrderCard = Flits(itemClone).find('.flits-rc-next-order-inner .flits-rc-inner-card').clone();
          if(i == '0'){Flits(itemClone).find('.flits-rc-next-order-inner').html('')}
          let upcomingOrderLink = `/tools/recurring/portal/${data.customer.hash}/manage/${elem.charge.id}?token=${window.flitsRcCustomerToken}`;
          let upcomingOrderPrice = Flits.formatMoney(Math.abs(elem.subscription.price * 100), Flits.money_format);
          Flits(itemClone).find('.flits-rc-upcoming-order-link').attr('href', upcomingOrderLink);
          Flits(nextOrderCard).find('.flits-rc-card-img img').attr('src', elem.subscription.product.images[0].small);
          Flits(nextOrderCard).find('.flits-rc-card-product-title').text(elem.subscription.product_title);
          Flits(nextOrderCard).find('.flits-rc-card-product-variant').text(elem.subscription.variant_title);
          Flits(nextOrderCard).find('.flits-rc-card-product-quantity').text(upcomingOrderPrice + ' X ' + elem.subscription.quantity );
          Flits(itemClone).find('.flits-rc-next-order-inner').append(nextOrderCard);
        });
    }
    let recentorder = data.orders[0];
    if(recentorder){
      //let recentOrdersLink = `tools/recurring/portal/${data.customer.hash}/orders?token=${window.flitsRcCustomerToken}`
      //Flits(itemClone).find('.flits-rc-recent-order .flits-rc-recent-orders a').attr('href', recentOrdersLink);
      Flits(itemClone).find('.flits-rc-recent-order .flits-rc-recent-order-date').text(setRcDate(recentorder.created_at));
      Flits(itemClone).find('.flits-rc-recent-order .flits-rc-recent-order-name').text('Order #' + recentorder.shopify_order_number);
      let rcOrderPrice = Flits.formatMoney(Math.abs(recentorder.total_price * 100), Flits.money_format);
      Flits(itemClone).find('.flits-rc-recent-order .flits-rc-recent-order-price').text(rcOrderPrice);
      Flits(itemClone).find('.flits-rc-recent-order .flits-rc-recent-order-link').attr('data-order-item', recentorder.id)
    }
    let recentOrders = data.orders;
    if(recentOrders.length > 1){
      Flits(recentOrders).each(function(index, ele){
        let recentPurchase = `<div class="flits-rc-recent-order-card flits-rc-card">
          <a href="#" class="flits-rc-recent-order-link" data-order-item="${ele.id}">
            <div class="flits-rc-recent-order-left">
              <div class="flits-rc-recent-order-date">${setRcDate(ele.created_at)}</div>
              <div class="flits-rc-recent-order-name">Order #${ele.shopify_order_number}</div>
            </div>
            <div class="flits-rc-inner-card">
              <div class="flits-rc-recent-order-right">
                <div class="flits-rc-recent-order-price">${Flits.formatMoney(Math.abs(ele.total_price * 100), Flits.money_format)}</div>
              </div>
              <div class="flits-rc-right-icon">
                <svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve"><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"></path> </g></g> </svg>
              </div>
            </div>
          </a>
        </div>`;
        Flits(itemClone).find('.flits-rc-purchase-history-row').append(recentPurchase);
      });
      if(recentOrders.length > 5){
       setTimeout(function(){
        Flits.getScript( "//cdnjs.cloudflare.com/ajax/libs/list.js/2.3.1/list.min.js" ).done(function( script, textStatus ) {
           var monkeyList = new List('flits-rc-purchase-list', {
            valueNames: ['flits-rc-recent-order-card'],
            page: 5,
            pagination: { innerWindow: 1, left: 1, right: 1 }
           }).on("updated", function (list) {
             // Flits('html, body').animate({
             //   scrollTop: Flits('.flits-rc-purchase-history').offset().top - 150
             // }, 500);
           });
        });
      }, 300); 
      }
    }
    Flits('.flits-recharge-subcription-main').html(itemClone);
  }
  async function fetchRcCustomer() {
        try {
            const res = await fetch(
                '/tools/recurring/get_rc_token/'+ Flits.customer_id
            ).then((res) => res.clone().text())
              .then((res) => JSON.parse(res.match(/{"rc_customer":.*}}/g)[0]));
                Flits.ajax({
                    url: `/tools/recurring/portal/${res.rc_customer.hash}/request_objects?token=${res.rc_customer.token}`,
                    type: "get",
                    dataType: "json",
                    data: {
                      schema:
                        '{ "charges": [], "schedule": [], "orders": [], "subscriptions": { "product": {} }, "customer": {}, "settings": {}, "store": {} }',
                    },
                  }).done(function (response) {
                      window.flitsRcCustomerToken = res.rc_customer.token;
                      window.flitsRcOders = response.orders;
                      window.flitsRcSubscriptions = response.subscriptions;
                      console.log(response);
                      makeRcBody(response);
                    }).fail(function (response) {
                      console.log(response);
                    });
            return res.rc_customer;
        } catch (err) {
            console.error(err);
        }
    }
    Flits(document).on('Flits:AccountPage:Visible', function(){
      fetchRcCustomer();
    })
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Rewards',
      url:'#Rewards',
      target:0,
      badge: null,
      icon: null,
      isShow: 1,
      loader:null,
      body_html: ''
   }
    settings.navs.splice(5, 0, obj);
     });
}(Flits));
